module.exports = __webpack_public_path__ + "img/__icon_JOLODA.5cfd5a37.svg";